import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e24639c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-2 h-16 line inline-flex items-center rounded-lg relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-16 border line-vertical" }, null, -1))
const _hoisted_4 = { clas: "mx-10" }
const _hoisted_5 = { class: "mx-6 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.lineIcon,
      class: "inline p-2"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}